import { render, staticRenderFns } from "./addVenue.vue?vue&type=template&id=7b4c6636&scoped=true"
import script from "./addVenue.vue?vue&type=script&lang=js"
export * from "./addVenue.vue?vue&type=script&lang=js"
import style0 from "./addVenue.vue?vue&type=style&index=0&id=7b4c6636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4c6636",
  null
  
)

export default component.exports